(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hamburger-menu"] && !Shopify.designMode) return;
  try {
    class LsNavMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.ls-nav__toggle');
      this.panel = this.querySelector('.ls-nav__panel');
      this.overlay = this.querySelector('.ls-nav__overlay');
      this.closeBtn = this.panel.querySelector('.ls-nav__close');

      /* Portal the overlay and panel to <body> so no page section's
         stacking context can ever paint above the open menu. Carry the
         custom-property styles from the host along. */
      this.panel.style.cssText += this.getAttribute('style') || '';
      this.overlay.style.cssText += this.getAttribute('style') || '';
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.panel);

      this.toggle.addEventListener('click', () => this.open());
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());

      this._onKeydown = (e) => {
        if (e.key === 'Escape' && this.panel.classList.contains('is-open')) {
          this.close();
        }
      };
      document.addEventListener('keydown', this._onKeydown);

      /* Live cart count. Both CartAddEvent and CartUpdateEvent fire as
         cart:update; only resource.item_count is the reliable TOTAL
         (add events put the quantity-just-added in data.itemCount). */
      this._onCartUpdate = (e) => {
        const badge = this.panel.querySelector('[data-ls-cart-count]');
        if (!badge) return;
        const cart = e.detail && e.detail.resource;
        let count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        const apply = (n) => {
          badge.textContent = '(' + n + ')';
          badge.hidden = n === 0;
        };
        if (count !== null) {
          apply(count);
        } else {
          fetch('/cart.js').then((r) => r.json()).then((c) => apply(c.item_count)).catch(() => {});
        }
      };
      document.addEventListener('cart:update', this._onCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
      document.removeEventListener('cart:update', this._onCartUpdate);
      this.overlay.remove();
      this.panel.remove();
    }

    open() {
      this.panel.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (window.lsLenis) window.lsLenis.stop();
      /* Move focus into the dialog without painting a focus ring on the × */
      this.panel.setAttribute('tabindex', '-1');
      this.panel.style.outline = 'none';
      this.panel.focus({ preventScroll: true });
    }

    close() {
      this.panel.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (window.lsLenis) window.lsLenis.start();
      this.toggle.focus();
    }
  }

  if (!customElements.get('ls-nav-menu')) {
    customElements.define('ls-nav-menu', LsNavMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
